import {Box, Paper, Typography} from "@material-ui/core"
import {useStyles} from "./styles"

export function StatCard({ icon, title, value, label }) {
  const classes = useStyles()
  return (
    <Paper className={classes.statCard}>
      {icon}
      <Box>
        {title && <Typography variant="body2" className={classes.statTitle}>{title}</Typography>}
        <Typography className={classes.statValue}>{value}</Typography>
        <Typography variant="body2" className={classes.statLabel}>{label}</Typography>
      </Box>
    </Paper>
  )
}
